import React from 'react';
import styles from './LaboratoryResultTableItem.module.scss';

interface Props {
	children: string | number | React.ReactElement | React.ReactElement[] | null;
	style?: React.CSSProperties;
}

const LaboratoryResultTableItem: React.FC<Props> = ({ children, style }) => {
	return (
		<div className={styles.wrapper} style={style}>
			{children}
		</div>
	);
};

export default LaboratoryResultTableItem;
